import React from 'react';
import { publications } from '../mock';
import { Card } from './ui/card';
import { FileText, ExternalLink } from 'lucide-react';
import './Publications.css';

const Publications = () => {
  return (
    <section id="publications" className="publications-section">
      <div className="publications-container">
        <div className="publications-header">
          <span className="section-label">Publications</span>
          <h2 className="section-title">Thought Leadership & Research</h2>
          <p className="section-description">
            Contributing to policy discourse through rigorous analysis and expert commentary
          </p>
        </div>

        <div className="publications-grid">
          {publications.map((pub) => (
            <Card key={pub.id} className="publication-card">
              <div className="publication-icon">
                <FileText size={32} />
              </div>
              <div className="publication-type">{pub.type}</div>
              <h3 className="publication-title">{pub.title}</h3>
              <p className="publication-description">{pub.description}</p>
              <div className="publication-footer">
                <div className="publication-meta">
                  <span className="publication-publisher">{pub.publisher}</span>
                  <span className="publication-date">{pub.date}</span>
                </div>
                <a 
                  href={pub.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="publication-link"
                >
                  <ExternalLink size={18} />
                </a>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;
